import React, { useState } from "react";

import {
  AccessTimeOutlined,
  CalendarMonthOutlined,
  Circle,
  InsertDriveFileOutlined,
  KeyboardArrowDown,
  MoreHoriz,
  OpenInNew,
  Pause,
  PersonOutline,
  PlayArrow,
} from "@mui/icons-material";
import {
  Box,
  ButtonBase,
  Card,
  CircularProgress,
  IconButton,
  Link,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
import { connect } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";

import AddJobImg from "../../../assets/images/add-job-button.png";
import { Tooltip } from "../../../common";
import {
  selectPostById,
  togglePostActiveOrInActive as togglePostActiveOrInActiveAction,
} from "../../../redux/slices/postsSlice";
import { flows } from "../../../static/data";
import SelectFlowModal from "../../Modals/SelectFlowModal";
import JobCriteriaPopup from "../JobCriteriaPopup";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import PROFILEICON from "../../../assets/icons/profile.png";

const JobLiveGridViewCard = ({ post, id, togglePostActiveOrInActive }) => {
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(post?.job_status);

  console.log("post", post);

  const handleStatusUpdate = async (_status) => {
    const oldStatus = status;
    try {
      setLoading(true);
      setStatus(_status);

      await togglePostActiveOrInActive({ job_id: post?.id, status: _status });
    } catch (e) {
      setStatus(oldStatus);
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  if (id === "create-job-button") {
    return (
      <>
        <ButtonBase
          onClick={() => setOpenModal(true)}
          sx={{
            width: "100%",
            border: 2,
            borderStyle: "dashed",
            borderRadius: "5px",
            borderColor: "#d1d1d1",
            backgroundImage: `url(${AddJobImg})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
            height: "350px",
          }}
        />
        <SelectFlowModal open={openModal} onClose={() => setOpenModal(false)} />
      </>
    );
  }

  return (
    <Card
      sx={{
        borderRadius: "16px",
        height: "350px",
        boxShadow: "0px 10px 20px 0px #0000000D",
      }}
    >
      {["active", "inactive"]?.includes(post?.job_status) && (
        <Box
          width="100%"
          bgcolor={post?.job_status === "active" ? "#22C55E" : "#EF4444"} // green or red
          display="flex"
          justifyContent="center"
          alignItems="center"
          gap={1}
          py={0.5}
        >
          <Circle sx={{ width: "7px", height: "7px", color: "white" }} />
          <Typography
            color="white"
            fontFamily="Outfit"
            fontWeight={500}
            fontSize="14px"
          >
            {post?.job_status === "active" ? "Active" : "Inactive"}
          </Typography>
        </Box>
      )}

      <Box
        p={2}
        height="70%"
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
      >
        <Box
          sx={{
            bgcolor: flows[post?.flow]?.bgcolor || "#FFECEC",
            borderRadius: "30px",
            px: 1,
            py: 0.5,
          }}
        >
          <Typography
            noWrap
            color={flows[post?.flow]?.color || "#FF7070"}
            fontSize="12px"
            fontWeight={700}
          >
            {flows[post?.flow]?.title || "--"}
          </Typography>
        </Box>

        <Box
          display="flex"
          width="100%"
          gap={1}
          my={1}
          justifyContent="space-between"
        >
          <Box flex={1}>
            <Typography fontSize="17px" textAlign="left" fontWeight={600}>
              {post?.job_name}
            </Typography>
            <Tooltip
              title={
                <Box>
                  {post?.assessment?.tests?.map((test, index) => (
                    <Box display="flex" gap={1} mb={1} key={index}>
                      <InsertDriveFileOutlined
                        sx={{ width: "17px", height: "17px", color: "#4bc7e1" }}
                      />
                      <Box>
                        <Typography fontSize="13px">
                          {test.test_name}
                        </Typography>
                        <Typography fontSize="10px" color="#999">
                          {test.questions?.length || 0} questions
                        </Typography>
                      </Box>
                    </Box>
                  ))}
                </Box>
              }
            >
              {post?.assessment?.tests?.length > 0 && (
                <Box display="flex" alignItems="center" gap={1}>
                  <InsertDriveFileOutlined
                    sx={{ width: "18px", color: "#888", height: "18px" }}
                  />
                  <Typography fontSize="13px" color="#888">
                    Assessments attached ({post?.assessment?.tests?.length}{" "}
                    Tests)
                  </Typography>
                </Box>
              )}
            </Tooltip>
          </Box>
          <Box flex={0.7} bgcolor="#99900">
            <Box display="flex" gap={0.5} justifyContent="flex-end">
              <CalendarMonthOutlined
                sx={{ width: "17px", height: "17px", color: "#999" }}
              />
              <Typography fontSize="11px">
                Exp: {dayjs(post?.expiry_date).format("MMM D")}
              </Typography>
            </Box>
            <Box display="flex" gap={0.5} justifyContent="flex-end">
              <AccessTimeOutlined
                sx={{ width: "17px", height: "17px", color: "#999" }}
              />
              <Typography fontSize="11px">
                Created: {dayjs(post?.created_at).format("MMM D")}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box display="flex" gap={0.5} alignItems="center">
          <PersonOutline
            sx={{ width: "16px", height: "16px", color: "#999" }}
          />
          <Typography fontSize="13px" fontWeight={500}>
            {post?.resume_received} Candidates -{" "}
            <span style={{ color: "#22C55E" }}>{post?.resume_passed}</span>{" "}
            Passed
          </Typography>
        </Box>
        <Box display="flex" my={1.5}>
          <Box
            sx={{
              bgcolor: post?.job_status === "active" ? "#E8F8FB" : "#FFECEC",
              borderRadius: "30px",
              p: 1,
              py: 0.5,
            }}
          >
            <Typography
              color={post?.job_status === "active" ? "#56CAE3" : "#FF7070"}
              fontSize="13px"
              fontWeight={600}
            >
              {post?.job_status === "active" ? "Hiring" : "No Hiring"}
            </Typography>
          </Box>
        </Box>
        <Box display="flex" gap={1} alignItems="center">
          <Box component="img" src={PROFILEICON} height={22} />
          <Typography noWrap fontSize="11px">
            {post?.recruiter?.personal_information?.first_name || "--"}
          </Typography>
        </Box>
      </Box>
      <Box
        p={2}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Box>
          <Link
            component={NavLink}
            to={`/resume-screening-candidates/${post?.id}`}
            sx={{
              p: 1,
              textDecoration: "none",
              fontSize: "12px",
              color: "#00637D",
              border: 1,
              borderColor: "#f2f6fd",
              borderRadius: "40px",
              mr: 1,
            }}
            startIcon={
              <OpenInNew
                sx={{ width: "14px", height: "14px", color: "#00637D" }}
              />
            }
          >
            View Candidate
          </Link>
          <JobCriteriaPopup post={post}>
            <Box borderRadius="40px" p={1} border={1} borderColor="#F2F6FD">
              <Typography color="#762FDE" fontFamily="Outfit" fontSize="13px">
                Criteria
              </Typography>
            </Box>
          </JobCriteriaPopup>
        </Box>

        <PopupState>
          {(popupState) => (
            <>
              <ButtonBase
                sx={{ fontSize: "14px", gap: 0.5 }}
                {...bindTrigger(popupState)}
              >
                <Box
                  width="20px"
                  height="20px"
                  borderRadius="50%"
                  className="center"
                  flexDirection="column"
                  p={2}
                  bgcolor={status === "active" ? "#E8F5E9" : "#FFE1E1"}
                >
                  {loading ? (
                    <CircularProgress color="white" size={17} />
                  ) : status === "active" ? (
                    <PlayArrow sx={{ color: "#2E7D4F" }} />
                  ) : (
                    <Pause sx={{ color: "#D32F2F" }} />
                  )}
                </Box>
                <KeyboardArrowDown sx={{ width: "16px", height: "16px" }} />
              </ButtonBase>
              <Menu {...bindMenu(popupState)}>
                <MenuItem
                  onClick={() => {
                    handleStatusUpdate("active");
                    popupState.close();
                  }}
                >
                  <Circle
                    sx={{
                      mr: 0.5,
                      color: "#2E7D4F",
                      width: "7px",
                      height: "7px",
                    }}
                  />
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontFamily: "Outfit",
                      fontWeight: 600,
                      color: "#2E7D4F",
                    }}
                  >
                    Active
                  </Typography>
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handleStatusUpdate("inactive");
                    popupState.close();
                  }}
                >
                  <Circle
                    sx={{
                      mr: 0.5,
                      color: "#D32F2F",
                      width: "7px",
                      height: "7px",
                    }}
                  />
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontFamily: "Outfit",
                      fontWeight: 600,
                      color: "#D32F2F",
                    }}
                  >
                    Inactive
                  </Typography>
                </MenuItem>
              </Menu>
            </>
          )}
        </PopupState>
      </Box>
    </Card>
  );
};

const mapStateToProps = (state, { id }) => ({
  post: selectPostById(state, id),
});

const mapDispatchToProps = {
  togglePostActiveOrInActive: togglePostActiveOrInActiveAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(JobLiveGridViewCard);
